import { useState, useEffect } from "react";
import { Redirect, Route } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { isAuthenticated } from "./adminAuth";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const [checking, setChecking] = useState(true);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    isAuthenticated().then((ok) => {
      setAuthed(ok);
      setChecking(false);
    });
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (checking) {
          return (
            <div className="admin-page admin-login">
              <Spinner animation="border" role="status" />
            </div>
          );
        }
        return authed ? <Component {...props} /> : <Redirect to="/admin/login" />;
      }}
    />
  );
};

export default ProtectedRoute;
